import axios from "axios";
import { auth } from "./firebase"

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  timeout: 0
})

api.interceptors.request.use(async (config) => {
  // Ottieni il token

  if (!auth.currentUser) {
    throw new Error("User is null.")
  }

  const tokenResult = await auth.currentUser.getIdTokenResult()
  const token = tokenResult.token

  // Aggiungi il token all'header Authorization
  config.headers.Authorization = `Bearer ${token}`;

  return config;
}, (error) => {
  // Gestisci errori nell'interceptor
  return Promise.reject(error);
});

api.interceptors.response.use(async (response) => {
  if (![200, 201, 204].includes(response.status)) {
    return Promise.reject(response.data)
  }
  return response.data
}, async (error) => {
  // Silently ignore request cancellations triggered via AbortController
  if (error.code === 'ERR_CANCELED' || error.name === 'CanceledError' || error.name === 'AbortError') {
    return Promise.reject(error);
  }
  if (error.response && error.response.data) {
    document.dispatchEvent(new CustomEvent('api-error', { detail: error.response.data }));
    if (error.response.data.code === 9) {
      console.log("Profile suspended. Force logout")
      await auth.signOut()
      if (window.location.pathname !== "/login") {
        window.location.reload()
      }
    }
    return Promise.reject(error.response.data)
  }

  if (error.response && error.response.data) {
    document.dispatchEvent(new CustomEvent('api-error', { detail: error.response.data }));
    return Promise.reject(error.response.data)
  }

  console.error(error)
  return Promise.reject(error)

})

export default api;
